module.exports = __webpack_public_path__ + "static/media/create-24px.552fcd66.svg";